<ng-container *ngIf="operatingModesActive$ | async | ready as feature">
  <mat-radio-group
    *ngIf="feature.properties?.value?.value"
    [ngModel]="feature.properties.value.value"
    class="flex flex-row flex-wrap gap-[20px] lt-lg:!hidden"
    [disabled]="!(feature | executable: 'setMode')"
    (change)="onOptionChange($event); trackCircuitOperatingMode()"
  >
    <ng-container *ngIf="feature | executable: featureCommands.setMode">
      <ng-container *ngFor="let mode of feature.commands?.setMode?.params?.mode?.constraints?.enum">
        <vi-radio-button
          [class.radio-wrapper-checked]="mode === feature.properties.value.value"
          data-at-operating-mode
          [value]="mode"
          [label]="mode | translateOperatingMode"
          [checked]="mode === feature.properties.value.value"
        >
        </vi-radio-button>
      </ng-container>
    </ng-container>

    <vi-radio-button
      [class.radio-wrapper-checked]="true"
      data-at-operating-mode
      *ngIf="!(feature | executable: featureCommands.setMode) && feature.properties?.value?.value"
      [value]="feature.properties.value.value"
      [label]="feature.properties.value.value | translateOperatingMode"
      [icon]="feature.properties.value.value | iconOperatingMode"
      [checked]="true"
    >
    </vi-radio-button>
  </mat-radio-group>

  <mat-form-field class="operating-mode-dropdown gt-md:!hidden" mat-select-height-large>
    <mat-label>{{ '+INSTALLATIONS.HEATING_CIRCUIT.STATUS_DROPDOWN' | translate }}</mat-label>
    <mat-select
      data-at-heating-circuit-operating-mode-dropdown
      gtm="onSelect"
      gtmAction="Open Heating Circuit Operating Mode dropdown"
      gtmCategory="heatingCircuit"
      (selectionChange)="onOptionChange($event); trackCircuitOperatingMode()"
      [disabled]="!(feature | executable: featureCommands.setMode)"
      [value]="feature.properties.value.value"
      fieldTextContentTooltip
    >
      <mat-option
        *ngFor="let mode of feature.commands?.setMode?.params?.mode?.constraints?.enum"
        [value]="mode"
        gtm="onSelect"
        gtmAction="Select Operating Mode"
        gtmCategory="heatingCircuit"
        fieldTextContentTooltip
        >{{ mode | translateOperatingMode }}</mat-option
      >
    </mat-select>
  </mat-form-field>
</ng-container>
